import { render, staticRenderFns } from "./InstTable.vue?vue&type=template&id=a945b576&scoped=true&"
import script from "./InstTable.vue?vue&type=script&lang=js&"
export * from "./InstTable.vue?vue&type=script&lang=js&"
import style0 from "./InstTable.vue?vue&type=style&index=0&id=a945b576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a945b576",
  null
  
)

export default component.exports